import { TellescopeModelFromName, useTellescopeMutation } from "@tellescope/tanstack-query";
import { EditableDateCell } from "./EditableDateCell";

export interface DueDateCellProps {
  isComplete: boolean;
  dueDateInMS: TellescopeModelFromName<"tickets">["dueDateInMS"];
  ticketId: string;
}

export const DueDateCell = ({ isComplete, dueDateInMS, ticketId }: DueDateCellProps) => {
  const updateTicketMutation = useTellescopeMutation({
    model: "tickets",
    method: "updateOne",
  });

  return (
    <EditableDateCell
      value={dueDateInMS ?? undefined}
      onChange={(newValue) => {
        if (!newValue) return;
        updateTicketMutation.mutateAsync({
          id: ticketId,
          dueDateInMS: newValue.getTime(),
        });
      }}
      hideTime
      relative={{ unit: "weeks", amount: 1, direction: "both" }}
      getBadgeColors={(value) => {
        if (isComplete || !dueDateInMS) return undefined;

        const currentTimestamp = new Date().getTime();
        const valueTimestamp = new Date(value).getTime();
        const msInDay = 1000 * 60 * 60 * 24;
        const diffInDays = (valueTimestamp - currentTimestamp) / msInDay;

        if (diffInDays <= 1) {
          return {
            bgColor: "bg-red-500 hover:bg-red-600",
            textColor: "text-red-50 hover:text-red-50",
          };
        } else if (diffInDays <= 3) {
          return {
            bgColor: "bg-yellow-200 hover:bg-yellow-300",
            textColor: "text-yellow-900 hover:text-yellow-900",
          };
        }
      }}
    />
  );
};
